<div class="table-responsive">
  <table class="custom-table custom-table-default custom-table-border-row">
    <thead>
      <tr>
        <th>Account</th>
        <th>Amount</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngIf="waitHandler.processing">
        <td colspan="999">
          <app-acc-loader></app-acc-loader>
        </td>
      </tr>
      <ng-container *ngIf="list$|async as list">
        <tr *ngIf="!list.length">
          <td *ngIf="!waitHandler.processing" colspan="999">Nothing here...</td>
        </tr>
        <tr *ngFor="let item of list">
          <td>
            <a (click)="onOpen(item)" [routerLink]="[routes.generalLedger, item.ID|toStr]|joinPath"
              class="hover:underline">
              <div>{{item.ID}}</div>
              <div class="text-muted text-xs">{{item.Account.Account||'No account'}}</div>
            </a>
          </td>
          <td class="text-end">
            <div>{{item.Amount|currency:'₱ '}}</div>
            <div *ngIf="item.Credit" class="text-muted text-xs">Credit</div>
            <div *ngIf="item.Debit" class="text-muted text-xs">Debit</div>
          </td>
        </tr>
        <tr *ngIf="list.length">
          <td colspan="999">
            <div class="text-end my-3">
              <a [routerLink]="routes.generalLedger" class="hover:underline">See more...</a>
            </div>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>